import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';

@Component({
    selector: 'app-custom-detail-component',
    templateUrl: './custom-detail-component.component.html',
    styleUrls: ['./custom-detail-component.component.scss'],
    standalone: false // NOSONAR
})
export class CustomDetailComponentComponent{
  private params: any;
  enableEdit: boolean = false;
  enableReport: boolean = false;
  enablecloseEvent: boolean = false;
  enableReopenEvent: boolean = false;
  enableimages: boolean = false;
  enableFinalEdit: boolean = false;
  rightArrow: boolean = false;
  deleteAccessible: boolean = true;
  isAccessible: boolean = true;
  constructor(
    private  readonly constants: Constants,
     private readonly aetStateService : AetStateService,
  ) {
  }
  agInit(params: any): void {
    // this.checkRoles();
    this.params = params;

    if (this.params.colDef.field == "safety_dashboard") {  // NOSONAR
      this.enableReport = true
      if(!(this.params.data.status == 'CLOSED')){  // NOSONAR
        this.enableEdit = true;
        this.enablecloseEvent = true;
      }
      else{
        this.enableReopenEvent = true;
      }
    }
    if (this.params.colDef.field == "childGridRenderer") {  // NOSONAR
      if(!(this.params.data?.status == 'CLOSED')){  // NOSONAR
      this.enableFinalEdit = true;
      this.enableimages = true;
      }
    }
    if (this.params.colDef.field == "rightArrow") {  // NOSONAR
      this.rightArrow = true
		}
  }
  
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    // this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);    
    // if (
    //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
    //   userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
    //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
    //   userRoles.includes(this.constants.LIOS_UAC_General_User)
    // ) {
      
      if (
        (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
        userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_LP)
      ) {
        
        // if (
        //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
        //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner)
        // ) {
        //   this.deleteAccessible = true;
        
        // }
        this.isAccessible = true;
        
      }
    // } 
  }

  refresh(_params: any): boolean {
    return false;
  }

  btnClickedHandler(action) {

		if (action == 'mainEdit') {  // NOSONAR
			this.params?.context.componentParent.safetyEdit(this.params.data);
    }
    if (action == 'childEdit') {  // NOSONAR
			this.params?.context.componentParent.finalSafetyEdit(this.params.data);
    }
    if (action == 'imagePop') {  // NOSONAR
			this.params?.context.componentParent.imagePopUp(this.params.data);
    }
    if (action == 'generate-popUp') {  // NOSONAR
			this.params?.context.componentParent.generatingPdf(this.params.data.safetyEventId);
    }
    if (action == 'reopen')  // NOSONAR
    {
      this.params?.context.componentParent.reOpenEvent(this.params.data.safetyEventId);
    }
    if (action == 'close-event') { // NOSONAR
			this.params?.context.componentParent.closeEvent(this.params.data.safetyEventId);
    }
    if (action == 'openChild') {  // NOSONAR
			this.params?.context.componentParent.openChild(this.params.data.reportId, this.params.data.safetyEventId);
		}
	}

}
